import { useT } from "@/lib/i18n";

export const Marquee = () => {
  const t = useT();
  const items = Array(4).fill(t.marquee).flat() as string[];
  const row = (half: string) => (
    <div className="flex" key={half}>
      {items.map((txt, i) => (
        <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
          <span className="mx-10">{txt}</span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-if-gold/60" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-if-line py-6"
    >
      <div className="flex w-max animate-marquee text-[11px] font-medium uppercase tracking-[0.35em] text-if-gold/60 md:text-xs">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
